import {
  FileText,
  ListChecks,
  ClipboardList,
  CalendarRange,
  Tags,
  DoorOpen,
  UserRoundPen,
  ClipboardCheck,
  FilePenLine,
} from "lucide-react";

/**
 * Exams hub — derived from schoolNavData "EXAMS" category.
 *
 * All /staff-panel/exam/* and /staff-panel/marks/* routes in App.js are
 * gated behind:
 *
 * ModuleGuard:
 *   moduleCode="EXAM_MANAGEMENT"
 *
 * PermissionGuard:
 *   permissionKey="EXAM_MANAGEMENT_VIEW"
 *
 * Marks entry / seating are detail pages reached from these list pages,
 * not separate hub cards.
 *
 * Individual link icons are semantic Lucide icons.
 * HubIcon handles the Quiet Duotone visual treatment centrally.
 */
export const hubExamMarksLinks = [
  {
    sectionTitle: "Exam Setup",
    sectionIcon: FileText,

    links: [
      {
        label: "Exams",
        url: "/exam/exams",
        desc: "Create & manage exams",
        module: "EXAM_MANAGEMENT",
        permission: "EXAM_MANAGEMENT_VIEW",
        icon: ClipboardList,
      },
      {
        label: "All Schedules",
        url: "/exam/schedules",
        desc: "Subject-wise exam schedules",
        module: "EXAM_MANAGEMENT",
        permission: "EXAM_MANAGEMENT_VIEW",
        icon: CalendarRange,
      },
      {
        label: "Exam Types",
        url: "/exam/types",
        desc: "Unit test, term, final, etc.",
        module: "EXAM_MANAGEMENT",
        permission: "EXAM_MANAGEMENT_VIEW",
        icon: Tags,
      },
      {
        label: "Exam Rooms",
        url: "/exam/rooms",
        desc: "Seating rooms & capacity",
        module: "EXAM_MANAGEMENT",
        permission: "EXAM_MANAGEMENT_VIEW",
        icon: DoorOpen,
      },
    ],
  },

  {
    sectionTitle: "Marks",
    sectionIcon: ListChecks,

    links: [
      {
        label: "Marks Assign",
        url: "/marks/eligible",
        desc: "Assign marks entry to teachers",
        module: "EXAM_MANAGEMENT",
        permission: "EXAM_MANAGEMENT_VIEW",
        icon: UserRoundPen,
      },
      {
        label: "Submitted Marks",
        url: "/marks/assignments",
        desc: "Review submitted marks",
        module: "EXAM_MANAGEMENT",
        permission: "EXAM_MANAGEMENT_VIEW",
        icon: ClipboardCheck,
      },
      {
        label: "Standalone Marks",
        url: "/marks/standalone",
        desc: "Marks outside exam schedules",
        module: "EXAM_MANAGEMENT",
        permission: "EXAM_MANAGEMENT_VIEW",
        icon: FilePenLine,
      },
    ],
  },
];

export default hubExamMarksLinks;